<div>
  <form [formGroup]="gstForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row" style="margin-top: 20px;">
          @if (addPermission) {
            <a class="__add_client" (click)="openGstForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Gst
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <table mat-table matSort [dataSource]="gstList" (matSortChange)="sortData($event)">
              <ng-container matColumnDef="code">
                <th class="header" mat-header-cell *matHeaderCellDef>
                  <div class="sorting_header">
                    <span mat-sort-header>SAC Code</span>
                    <input type="search" placeholder="Search by SAC Code" formControlName="code" matInput
                      autocomplete="off" class="mat-input-custom">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.code}}</td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th class="header" mat-header-cell *matHeaderCellDef>
                    <div class="sorting_header">
                      <span mat-sort-header>SAC Name</span>
                      <input type="search" placeholder="Search by SAC Name" formControlName="name" matInput
                        autocomplete="off" class="mat-input-custom">
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.name}}</td>
                  </ng-container>
                  <ng-container matColumnDef="description">
                    <th class="header" mat-header-cell *matHeaderCellDef>
                      <div class="sorting_header">
                        <span mat-sort-header>Description</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.description}}</td>
                  </ng-container>
                  <ng-container matColumnDef="type">
                    <th class="header" mat-header-cell *matHeaderCellDef>
                      <div class="sorting_header">
                        <span mat-sort-header>Gst Type</span>
                        <mat-select formControlName="type" placeholder="Search by Gst Type">
                          @for (status of gstTypes; track status) {
                            <mat-option [value]="status.key">
                              {{status.label}}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.type}}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>
                      <span class="mat-sort-header-content" >Action</span>
                    </th>
                    <td mat-cell class="__action_row" *matCellDef="let element">
                      <span class="__action_edit_icon" (click)="openGstForm(element.id)" style="margin-right: 10px;">
                        <mat-icon>create</mat-icon>
                      </span>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="gstColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: gstColumns;"></tr>
                </table>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </form>
      @if (viewPermission) {
        <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [length]="totalSectorRecords"></mat-paginator>
      }
    </div>